"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _fluxActions = require("flux-actions");

var ActionTypes = _interopRequireWildcard(require("MeetingsLib/redux/actions/ActionTypes"));

var _timezone = require("MeetingsLib/constants/timezone");

var _getTimezoneGroups = _interopRequireDefault(require("timezone-utils/utils/getTimezoneGroups"));

var _handleActions;

var initialState = 'Europe/Belfast';

var _default = (0, _fluxActions.handleActions)((_handleActions = {}, (0, _defineProperty2.default)(_handleActions, ActionTypes.SET_TIMEZONE, function (state, action) {
  return action.timezone;
}), (0, _defineProperty2.default)(_handleActions, ActionTypes.PUBLIC_AVAILABILITY_INFO_FETCH_SUCCEEDED, function (state, action) {
  var timezone = action.payload.bookInfo.customParams.timezone;

  if (state === _timezone.INVALID_TZ_GUESS) {
    return (0, _getTimezoneGroups.default)().resolve(timezone);
  }

  return state;
}), _handleActions), initialState);

exports.default = _default;
module.exports = exports.default;